export default __webpack_public_path__ + "static/media/orderbook_navicon-light.aad0ea13.svg";